var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_9500)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5296 21.2939L16.0911 15.3296H11.9999H7.90871L4.47021 21.2939C4.74084 21.4584 5.05922 21.5539 5.35637 21.5539H18.6434C18.9405 21.5539 19.2589 21.4584 19.5296 21.2939Z",
    fill: "#467CBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0913 15.3296L19.5298 21.2939C19.7739 21.1506 19.9808 20.9543 20.1135 20.7261L22.7826 16.1255C22.9152 15.8974 22.9895 15.6161 23.0001 15.3296H16.0913Z",
    fill: "#E83927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0912 15.3295H22.9948C23.0054 15.0165 22.9417 14.6928 22.7931 14.4381L21.2596 11.7796L16.1231 2.85435C15.9745 2.59965 15.7357 2.37678 15.4651 2.2229L12.0054 8.22966L14.0536 11.7796L16.0912 15.3295Z",
    fill: "#F9BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 8.22962L15.4595 2.22287C15.2101 2.0849 14.9342 2 14.6688 2H9.33068C9.06536 2 8.78413 2.0849 8.54004 2.22287L11.9998 8.22962Z",
    fill: "#007C3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 8.22966L8.53513 2.2229C8.2592 2.37678 8.02042 2.59965 7.87715 2.85435L2.73532 11.7796L1.2018 14.4381C1.05322 14.6928 0.989544 15.0111 1.00016 15.3295H7.90368L9.95192 11.7796L12.0002 8.22966Z",
    fill: "#1EA74B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90883 15.3296H1C1.01061 15.6108 1.0849 15.8921 1.21756 16.1255L3.88664 20.7261C4.0193 20.9543 4.22624 21.1506 4.47033 21.2939L7.90883 15.3296Z",
    fill: "#1C63AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_9500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19.5538,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google_drive.9ef54157a3a41ddd3c51d9bfca4f6e5b.svg";
export { ForwardRef as ReactComponent };